export default __webpack_public_path__ + "static/media/forward-to-last-page.984890af.svg";